import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-stat',
  templateUrl: './stat.component.html',
  styleUrls: ['./stat.component.scss']
})
export class StatComponent implements OnInit {

  @Input() statData: any = {};
  @Input() title: string;
  @Input() value: string;
  @Input() icon: string;
  @Input() navigateUrl: string;

  constructor(private router: Router) { }

  ngOnInit(): void {
  }

  navigate(type: string) {
    switch (type) {
      case 'totalDoc':
        this.router.navigate(['documents']);
        break;
      case 'users':
        this.router.navigate(['customers'], {
          queryParams: { status: 'Active' }
        });
        break;
      default:
        console.warn('Invalid type');
    }
  }

}
